import { ProviderRequestInterface } from '../../../interfaces/request/provider/provider-request-interface';

export class CpProviderRequestModel implements ProviderRequestInterface {
  card_number: string = '';
  date: string = '';
  specialty: number = -1;
  service: number = -1;
  subservice: number = -1;
  out_of_network: boolean = false;
  building_name: string = '';
  doctor_name: string = '';

  constructor(init?: Partial<CpProviderRequestModel>) {
    Object.assign(this, init);
  }
}
